<div class="page-shell">
  <mat-toolbar class="header">
    <span>{{ "accounts.accountsHeader" | translate }}</span>
  </mat-toolbar>

  <div class="accounts-container">
    <div class="content-section">
      <div class="accounts-section">

        <form class="filters-row search-form" (submit)="$event.preventDefault()">
          <mat-form-field class="search-field" appearance="outline" subscriptSizing="dynamic">
            <mat-icon matPrefix>search</mat-icon>
            <input
              type="text"
              matInput
              [formControl]="accountForm"
              [disabled]="isLoading"
              [placeholder]="'account' | translate"
              [attr.aria-label]="'account' | translate"
            />
          </mat-form-field>
        </form>

        <div class="cards-grid" *ngIf="(accounts$ | async)?.length > 0">
          <mat-card
            appearance="outlined"
            *ngFor="let option of filteredOptions$ | async"
            class="account-card"
          >
            <div class="card-content">
              <div class="card-info">
                <div class="card-title" [class.noName]="!option.name">
                  {{ option.name ?? "accounts.noName" | translate }}
                </div>
                <div class="card-subtitle">{{ option.domain }}</div>
              </div>
              <div class="logo-container">
                <img
                  *ngIf="option.photoUrl"
                  [src]="option.photoUrl"
                  [alt]="option.domain + ' logo'"
                  [title]="option.domain + ' logo'"
                  class="company-logo"
                />
                <div *ngIf="!option.photoUrl" class="logo-placeholder">
                  <mat-icon>business</mat-icon>
                  <span>{{ option.domain }}</span>
                </div>
              </div>
              <button
                mat-raised-button
                color="primary"
                type="button"
                [disabled]="!!selectingDomain"
                (click)="changeAccount(option)"
              >
                <mat-spinner
                  *ngIf="selectingDomain === option.domain"
                  diameter="20"
                  class="dc-btn-spinner"
                ></mat-spinner>
                <span *ngIf="selectingDomain !== option.domain">{{
                  "select" | translate
                }}</span>
              </button>
            </div>
          </mat-card>
        </div>

        <div
          class="empty-state"
          *ngIf="!isLoading && (accounts$ | async)?.length === 0"
        >
          <mat-icon class="empty-state__icon">business</mat-icon>
          <p>{{ "accounts.empty" | translate }}</p>
        </div>
      </div>
    </div>

  </div>

  <div class="dbc1-loading dbc1-loading--overlay" *ngIf="isLoading">
    <app-loading></app-loading>
  </div>
</div>
